import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  TextField,
  Typography,
  Box,
  Toolbar,
} from "@mui/material";

import { Menu as MenuIcon } from "@mui/icons-material";

import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarTenantFlag from "./NavbarTenantFlag";
import NavbarMsrViewToggle from "./NavbarMsrViewToggle";
import NavbarUserDropdown from "./NavbarUserDropdown";

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

var env = import.meta.env.VITE_ENVIRONMENT;

const Navbar = React.memo(({ onDrawerToggle }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <AppBar position="sticky" elevation={1}>
        <Toolbar>
          <Grid container>
            <Grid item sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={onDrawerToggle}
                size="large"
              >
                <MenuIcon />
              </IconButton>
            </Grid>
            {env && env == "development" ? (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Typography
                  variant="h1"
                  noWrap
                  component="div"
                  sx={{ flexGrow: 1 }}
                >
                  DEVELOPMENT
                </Typography>
              </Grid>
            ) : null}

            <Grid item xs />

            <Grid item>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <NavbarMsrViewToggle />
                <NavbarTenantFlag />
                <NavbarNotificationsDropdown />
                <NavbarUserDropdown />
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
});

export default React.memo(withTheme(Navbar));
